import React, { useRef, useEffect, useState  } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // IMPORTANTE
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import logo from "../logo.svg"; // Importar logo
import { Card } from 'react-bootstrap';
import { Dropdown } from "primereact/dropdown";
import { Toolbar } from 'primereact/toolbar';
import { SplitButton } from 'primereact/splitbutton';
import { getFacturas}from '../api/facturaService'; 
import { format } from 'date-fns';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

function MainReportes() {
  const [facturas, setFacturas] = useState([]);
  const dt = useRef(null);
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState('center');
  const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
const [pagos, setPagos] = useState([]);
const [pagosDialog, setPagosDialog] = useState(false);
const [checked, setChecked] = useState(false);

  const datos = [
    { nombre: "Producto 1", cantidad: 2, precio: 50, total: 100 },
    { nombre: "Producto 2", cantidad: 1, precio: 80, total: 80 },
    { nombre: "Producto 3", cantidad: 3, precio: 30, total: 90 },
  ];

  const generarPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();

console.log("Ancho:", pageWidth, "Alto:", pageHeight);

     // ======== ENCABEZADO ========
    doc.setFontSize(16);
    doc.text("Mi Empresa S.A. de C.V.", 14, 20);
    doc.setFontSize(10);
    doc.text("RFC: ABC123456789", 14, 26);
    doc.text("Lugar de expedición: Ciudad de México", 14, 32);

    // Fecha y folio a la derecha
    const fecha = new Date().toLocaleDateString();
    doc.text(`Fecha: ${fecha}`, 150, 20);
    doc.text("Folio: 000123", 150, 26);

    // ======== DATOS DEL CLIENTE ========
    doc.setFontSize(12);
    doc.text("Cliente: Juan Pérez", 14, 45);
    doc.text("Dirección: Calle Falsa 123", 14, 51);
    doc.text("Tel: 555-123-4567", 14, 57);


    const body = datos.map(p => [
      p.nombre,
      p.cantidad,
      `$${p.precio.toFixed(2)}`,
      `$${(p.cantidad * p.precio).toFixed(2)}`
    ]);

    autoTable(doc, {
      startY: 70,
      head: [["Descripción", "Cantidad", "Precio Unitario", "Importe"]],
      body,
    });
     // ======== PIE CON SUBTOTAL, IVA Y TOTAL ========
    const finalY = doc.lastAutoTable.finalY || 70;
    const subtotal = datos.reduce((sum, p) => sum + p.cantidad * p.precio, 0);
    const iva = subtotal * 0.16;
    const total = subtotal + iva;

    doc.text(`Subtotal: $${subtotal.toFixed(2)}`, 150, finalY + 10);
    doc.text(`IVA (16%): $${iva.toFixed(2)}`, 150, finalY + 16);
    doc.setFontSize(14);
    doc.text(`Total: $${total.toFixed(2)}`, 150, finalY + 24);
// Dibujar líneas verticales cada 10 mm
for (let x = 10; x < pageWidth; x += 10) {
  doc.line(x, 0, x, pageHeight);
  doc.text(String(x), x, 5); // etiqueta con valor de X
}

// Dibujar líneas horizontales cada 10 mm
for (let y = 10; y < pageHeight; y += 10) {
  doc.line(0, y, pageWidth, y);
  doc.text(String(y), 2, y); // etiqueta con valor de Y
}
    // ======== GUARDAR PDF ========
  doc.save("factura.pdf");
  };
 const startContent = (
        <React.Fragment>
            <h5>Facturas procesadas</h5>
        </React.Fragment>
    );
  const endContent = (
        <React.Fragment>
            {/* <SplitButton label="Save" icon="pi pi-check"></SplitButton> */}
            <Button label="Exportar CSV" icon="pi pi-file-excel" onClick={() => dt.current.exportCSV()} /> 
            <Dropdown className="w-full md:w-14rem"></Dropdown>
            <Dropdown className="w-full md:w-14rem"></Dropdown>
        </React.Fragment>
    );
    const actionBodyTemplate = (rowData) => {//botones de accion
            return (
                <React.Fragment>
                    <Button icon="pi pi-eye" rounded outlined className="mr-2" style={{ color: 'green' }}  onClick={() => show(rowData)}/>
                    {/* onClick={() => editCliente(rowData)} */}
                    <Button icon="pi pi-times" rounded outlined severity="danger"  /> 
                    {/* onClick={() => confirmDeleteCliente(rowData)} */}
                    
                </React.Fragment>
            );
        };
    
     const show = (factura) => {
       setPosition("top");
       setFacturaSeleccionada(factura);
       
        setVisible(true);
    };

      useEffect(() => {
        const fetchData = async () => {
          const data = await getFacturas();
          //console.log('CLIENTES DESDE EL BACKEND:', data);// 👈 aquí revisamos qué viene
          //setFacturas(data);
            setFacturas(transformarFacturas(data));
        };
    
        fetchData();
      }, []);
   const transformarFacturas = (facturas) => {
    return facturas.map(f => ({
      facturaId: f.facturaId,
      folio: `${f.serie}-${f.folio}`,
      tipo: f.tipoFactura,
      nombreEmisor: f.datosReceptor?.[0]?.razonSocial || "N/A",
      ruc: f.datosReceptor?.[0]?.ruc || "N/A",
      fecha: new Date(f.fechaEmision),
      estado: f.status,
      total: f.totalPagar
    }));
  };
const formatFecha = (rowData) => {
  if (!rowData.fecha) return '';
  return format(new Date(rowData.fecha), 'dd-MM-yyyy');
};
const abrirPagos = async () => {
  if (!facturaSeleccionada) return;

  // 🔹 Aquí deberías hacer la consulta a tu backend
  // Ejemplo de pagos simulados
  const pagosEjemplo = [
    // { id: 1, parcial: 200, pagado: 200, saldo: facturaSeleccionada.total - 200 },
  // { id: 2, parcial: 100, pagado: 100, saldo: facturaSeleccionada.total - 300 },
  ];

  setPagos(pagosEjemplo);
  setPagosDialog(true);
};
const calcularTotalesPagos = () => {
  const total = facturaSeleccionada?.total || 0;
  const pagado = pagos.reduce((acc, p) => acc + p.pagado, 0);
  const restante = total - pagado;
  return { total, pagado, restante };
};

  return (
    <>
      {/* <Button label="Descargar PDF" icon="pi pi-file-pdf" onClick={generarPDF} />
      <Button label="Exportar CSV" icon="pi pi-file-excel" onClick={() => dt.current.exportCSV()} /> */}

      <h4>Consultas de facturas</h4>
  
      <Card>
         <Toolbar  start={startContent}  end={endContent}  >
            
           </Toolbar>
       

      </Card>
    <div>
      <Card>
      <DataTable  ref={dt} value={facturas} paginator rows={5} responsiveLayout="scroll">
        <Column field="facturaId" header="#" />
        <Column field="folio" header="Folio" />
        <Column field="tipo" header="Tipo" />
        <Column field="nombreEmisor" header="Nombre" />
        <Column field="ruc" header="RUC" />
        <Column field="fecha" header="Fecha" body={formatFecha}/>
         <Column field="estado" header="Estado" />
          <Column field="total" header="Total" />
           <Column  header="Accion"  body={actionBodyTemplate} />
      </DataTable>
      </Card>
    </div>

    <Dialog header={`Factura ${facturaSeleccionada ? facturaSeleccionada.folio : ""}`}
     visible={visible} style={{ width: '50vw' }} draggable={false} resizable={false}
     onHide={() => setVisible(false)}
      position={position}>
        {facturaSeleccionada && (
        <div>
          <div class="field grid">
            <label for="firstname4" class="col-12 mb-2 md:col-2 md:mb-0"><strong>Nombre:</strong> </label>
            <div class="col-12 md:col-10"> {facturaSeleccionada.nombreEmisor} </div>
          </div>
          <div class="field grid">
            <label for="firstname4" class="col-12 mb-2 md:col-2 md:mb-0"><strong>Receptor:</strong> </label>
            <div class="col-12 md:col-10"> {facturaSeleccionada.ruc}</div>
          </div>
          <div class="field grid">
            <div class="field col">
              <label for="firstname4" class="col-4 md"><strong>Fecha de Emisión:</strong> </label>
                {format(new Date(facturaSeleccionada.fecha), "dd-MM-yyyy")}
            </div>
            <div class="field col">
              <label for="firstname4" ><strong>Tipo: </strong>   </label>
                {facturaSeleccionada.tipo}
            </div>
          </div>
          <div class="field grid">
            <label for="firstname4" class="col-12 mb-2 md:col-2 md:mb-0"><strong>Método de Pago:  </strong> </label>
            <div class="col-12 md:col-10">{facturaSeleccionada.metodoPago || "No especificado"}</div>     
          </div>
        </div>
  
  )}
  <div class="field grid">
    <div class="field col">
      <Button  label="Ver Pagos" icon="pi pi-dollar" onClick={abrirPagos} className="p-button-success" />
    </div>
    <div class="field col">
       <Button label="Descargar PDF" icon="pi pi-file-pdf" severity="info" onClick={generarPDF} />
    </div>
  </div>
  
      </Dialog>

      <Dialog
  header={`Pagos de la Factura ${facturaSeleccionada ? facturaSeleccionada.folio : ""}`}
  visible={pagosDialog}
  style={{ width: "50vw" }}
  draggable={false}
  resizable={false}
  onHide={() => setPagosDialog(false)}
>
  <DataTable value={pagos} responsiveLayout="scroll">
    <Column field="id" header="#" />
    <Column field="parcial" header="Parcial" />
    <Column field="saldo" header="Saldo" />
    <Column field="pagado" header="Pagado" />
  </DataTable>
 
  <div style={{ marginTop: "1rem", textAlign: "right" }}>
    <p><strong>Total Factura:</strong> {calcularTotalesPagos().total.toFixed(2)}</p>
    <p><strong>Pagado:</strong> {calcularTotalesPagos().pagado.toFixed(2)}</p>
    <p><strong>Restante:</strong> {calcularTotalesPagos().restante.toFixed(2)}</p>
  </div>
  <div className="flex align-items-center">
 <Checkbox onChange={e => setChecked(e.checked)} checked={checked}></Checkbox>

 </div>
</Dialog>


    </>
  );
}

export default MainReportes; 
